import {FC} from 'react'
import {EmptyLayoutProps} from './Layout.types'

export const EmptyLayout: FC<EmptyLayoutProps> = ({children}) => {
  return <>{children}</>
}
